import React from 'react';
import { COUNTRY_CODES } from '../../../constants/enums';
import InfoBox from '../InfoBox/InfoBox.jsx';
import InfoBoxNO from '../InfoBox/InfoBoxNo.jsx';
import InfoBoxDK from '../InfoBox/InfoBoxDK.jsx';

const CountryInfoBox = ({ 
    country, 
    orderOrderLines, 
    initialOrderlinesData, 
    infoBoxData, 
    orderData, 
    campaignPromiseType, 
    campaignType, 
    parameters }) => {

  const commonProps = {
      orderOrderLines,
      initialOrderlinesData,
      orderlinesData: infoBoxData,
      orderData,
      campaignPromiseType,
      productType: campaignType,
      parameters,
  };

  switch (country) {
    case COUNTRY_CODES.NORWAY:
      return <InfoBoxNO {...commonProps} />;
    case COUNTRY_CODES.DENMARK:
      return <InfoBoxDK {...commonProps} />;
    case COUNTRY_CODES.SWEDEN:
    default:
      return <InfoBox {...commonProps} />;
  }
};

export default CountryInfoBox;
